import script from "./Pin.vue?vue&type=script&lang=ts&setup=true"
export * from "./Pin.vue?vue&type=script&lang=ts&setup=true"

import "./Pin.vue?vue&type=style&index=0&id=3af80a0d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3af80a0d"]])

export default __exports__